// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d752f903","41":"585b121d","70":"427600fd","124":"2e68f6e8","145":"889c7b4e","241":"68f17cc7","319":"09051856","478":"d38762bb","552":"80423304","804":"a93d6d6b","874":"dbc2e95e","918":"a8fa5fcd","920":"651430cf","945":"116b1524"}[chunkId] + ".chunk.js";
};